import { useEffect } from 'react';

const useScript = (url: string, async = true, defer = true, crossorigin = 'anonymous') => {
  useEffect(() => {
    let script: HTMLScriptElement;

    if (url) {
      const exists = document.querySelector(`script[src^="${url}"]`);

      if (exists === null) {
        script = document.createElement('script');

        script.src = url;

        script.async = async;
        script.defer = defer;
        script.crossOrigin = crossorigin;

        document.body.appendChild(script);
      }
    }

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [url, async, defer, crossorigin]);
};

export default useScript;
